import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(process.env.VUE_APP_AUTH_TOKEN);
    if (token) {
      config.headers.Authorization = `${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default axios;
